import { combineReducers } from '@reduxjs/toolkit'

import { REDUCER_INDEX } from '../constants'
import current from '../reducer/current'
import * as fixtures from './fixtures'
import * as institution from './institution'
import * as permissions from './permissions'

export * as fixtures from './fixtures'
export * as institution from './institution'
export * as permissions from './permissions'

export const actions = {
  ...institution.actions,
  ...fixtures.actions,
  ...permissions.actions,
}

export const epics = [...institution.epics, ...fixtures.epics, ...permissions.epics]

export const reducer = combineReducers({
  current,
  fixtures: fixtures.reducer,
  institution: institution.reducer,
  permissions: permissions.reducer,
})

export const selectors = {
  fixtures: ({ [REDUCER_INDEX]: state }: { [REDUCER_INDEX]: ReturnType<typeof reducer> }) => state.fixtures,
  institution: ({ [REDUCER_INDEX]: state }: { [REDUCER_INDEX]: ReturnType<typeof reducer> }) => state.institution,
  permissions: ({ [REDUCER_INDEX]: state }: { [REDUCER_INDEX]: ReturnType<typeof reducer> }) => state.permissions,
}
